import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
// import moment from 'moment';
export default class ModalDialogue extends React.Component{
	constructor(){
		super()
		this.state = {
			ActiveDataModal: null
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.modalData !== null){
			nextState.ActiveDataModal = nextProps.modalData
			return true
		}
		return false
	}

	render(){
		// console.log(this.state.ActiveDataModal.NextReservation)
		if (this.state.ActiveDataModal === null || 
			this.state.ActiveDataModal.Asset.NextReservation === null)
		{
			return null
		}else{
			return(
				<Modal isOpen={this.props.isOpen} toggle={this.props.closeModal}>
					<ModalHeader toggle={this.props.closeModal}>{'Message'}</ModalHeader>
					<ModalBody>
						<div className="row">			
							<div className="form-group col-sm-12">
								{/*<label htmlFor="Message">Message</label>*/}
								<span><strong>{'Is this related to booking you created for starting ' + moment(this.state.ActiveDataModal.Asset.NextReservation.StartDate).format('ll') + ' to ' + moment(this.state.ActiveDataModal.Asset.NextReservation.FinishDate).format('ll') + ' ?'}</strong></span>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button className="btn btn-danger" onClick={()=>{this.props.closeModal(); this.props.openModalAcceptQRReassign(this.state.ActiveDataModal)}}>No</Button>
						<Button 
							color="primary" 
							onClick={()=>{
								this.props.closeModal(true); 
								this.props.openModalAcceptQRReassign(this.state.ActiveDataModal)
							}}>Yes</Button>
					</ModalFooter>
				</Modal>
			)
		}
	}
}


// WEBPACK FOOTER //
// ./src/App/qrreader/helper/component/Modal/ModalDialogueQR.js